/**
 * Created by SH: 20/02/2020
 */

import { gsap } from 'gsap';
import { Sequence } from '../../core/displayobject/Sequence';
import { ReelStartCallbacks, ReelStopCallbacks } from '../../core/reel/IData/IReelData';
import { ReelState } from '../../core/reel/ReelEngineView';
import { ReelBaseSymbol } from '../../core/reel/symbol/ReelBaseSymbol';
import { ReelSymbolStates } from '../../core/reel/symbol/ReelSpriteSymbolArea';
import { BasicSymbolType } from '../../core/reel/symbol/config/IReelSymbolStruct';
import { GameSetting } from '../../core/setting/GameSetting';
import { ArrayHelper } from '../../core/utils/ArrayHelper';
import { Helper } from '../../core/utils/Helper';
import { MathHelper } from '../../core/utils/MathHelper';
import { BeheadedEngineView } from './BeheadedEngineView';
import { BeheadedReelEngine } from './BeheadedReelEngine';
import { BeheadedRope } from './symbol/BeheadedRope';
import { BeheadedSymbol } from './symbol/BeheadedSymbol';
import { Beheaded } from '../Beheaded';
import { GraveSnatchers } from '../Font/GraveSnatchers';
import { BLEND_MODES } from 'pixi.js';

export class BeheadedEngineController extends BeheadedEngineView {
    private attentionSeq: Sequence;
    private cutIndicator: number = 4;
    private rope: BeheadedRope;

    private ropeIsOnSeperated:boolean = false;
    private _objects: PIXI.DisplayObject[] = [];
    private collectedTxt: PIXI.Text;

    public get AllSticky(): BeheadedSymbol[] {
        return this._stickyContainer.children as BeheadedSymbol[];
    }

    public get currentCutIndx(): number {
        return this.cutIndicator;
    }

    protected initReel(): void {
        this.setCurrentReelSet(this._nextReelSetName);

        let possAdded: number = 0;
        let symInitPos: number = this._stopReelSet.length;
        for (var i = -this.overflowAmount; i < this.config.WINDOW_AMOUNT; i++) {
            let symName: string = this._stopReelSet[symInitPos % this._stopReelSet.length];
            if (!symName || symName == BasicSymbolType.EMPTY) symName = 'L1';
            const symbol: ReelBaseSymbol = this.createNewSymbol(i, symName);

            if (i == -this.overflowAmount && this.overflowAmount) {
                let overflowAmount: number = (symbol.symbolHeight - this.engine.stepDistance) * 0.5;
                possAdded = symbol.symbolHeight * i + overflowAmount;
                symbol.setPosID(-symbol.stackedValue);
                i += symbol.stackedValue - 1;
            } else if (this.AllSymbols.length) {
                symbol.setPosID(ArrayHelper.fetchLastValue(this.AllSymbols[this.AllSymbols.length - 1].posID) + 1);
                possAdded += Math.abs(symbol.symbolHeight) * 0.5;
            }

            symbol.position = new PIXI.Point(0, possAdded);

            possAdded += Math.abs(symbol.symbolHeight) * 0.5;

            this.addSymbol(symbol);
            symInitPos++;
        }
        this.setVisibleForOverflowSymbols(false);
        this.addAndRemoveOutOfBound();
        this.sortChildren();

        this._hasInit = true;
    }

    protected setVisibleForOverflowSymbols(value: boolean): void {
        super.setVisibleForOverflowSymbols(value);
    }

    addChildObjOrder(): void {
        this.rope = this._animationContainer.addChild(new BeheadedRope());
        this.rope.zIndex = -5;
        super.addChildObjOrder();

        this.collectedTxt = this.addChild(new PIXI.Text('x1'));
        this.collectedTxt.style = {
            fontFamily: GraveSnatchers.FAMILY,
            fontSize: '30px',
            stroke: '#000000',
            strokeThickness: 10,
            fill: '#ce1313',
            dropShadow: true,
            dropShadowColor: '#000000',
            dropShadowAlpha: 0.7,
            dropShadowAngle: 0.6,
            dropShadowDistance: 8,
            padding: 20,
            lineJoin: 'round',
        };
        this.collectedTxt.alpha = 0;
        this.collectedTxt.anchor.set(0.5, 0.5);
    }

    public getARope(index: number): PIXI.Sprite {
        return this.rope.getSingleRope(index);
    }

    public getSymbol(symbolID: number): BeheadedSymbol | undefined {
        // Fetching the Sticky first.
        const sticky: BeheadedSymbol | undefined = this.AllSticky.find((sym: BeheadedSymbol) => {
            return sym.posID.includes(symbolID);
        });
        if (sticky) return sticky;

        const sym: BeheadedSymbol | undefined = this.AllSymbols.find((sym: BeheadedSymbol) => {
            return sym.posID.includes(symbolID);
        });
        if (sym) return sym;

        return undefined;
    }

    public setCutIndicator(cutIndex: number): void {
        this.cutIndicator = cutIndex == -1 ? this.symbolConfAmount : cutIndex;
    }

    protected onStartCompleted(): void {
        this.state.set(ReelState.STEP);

        if (this.isAvalanching) this.removeCuttedSymbols();
        else {
            while (this.AllSymbols.length) {
                this.AllSymbols[0].remove();
                this.AllSymbols.shift();
            }
        }

        while (this._stickyContainer.children.length) {
            (this._stickyContainer.removeChildAt(0) as BeheadedSymbol).remove();
        }

        Helper.triggerIfExist(this.startCallbacks.started);
    }

    private removeCuttedSymbols(): void {
        let ammRemoved: number = 0;
        //remove the symbols below;
        let cutToAmount = this.cutIndicator;
        while (cutToAmount < this.symbolConfAmount) {
            let symToRemove = this.getSymbol(cutToAmount);
            ammRemoved += symToRemove?.isHighValSym ? 1 : 0;
            symToRemove?.remove();
            cutToAmount++;
        }
    }

    private evalString:string[];
    public applyEvalReel(evalReel:string[]):void{
        this.evalString = evalReel;
    }

    public get ammScattersCollected():number{
        let amm = 0;
        this.evalString.forEach((v, pos) => {
            if (this.cutIndicator <= pos && v == "S") amm++;
        })
        return amm;
    }

    fetchDroppedScatters(){
        const tl = gsap.timeline();

        if(!this.isAvalanching) return tl;

        let amm = this.ammScattersCollected;

        if(!amm) return tl;

        Beheaded.overlayAnim.addChild(this.collectedTxt);
        
        this.collectedTxt.text = "x"+amm;
        
        this.collectedTxt.position.set(Helper.copyLocalPosition(this.collectedTxt, this).x, this.maxHeight + 60)

        const seq = Beheaded.overlayAnim.playStandAloneSequence(Beheaded.assetLoader.getTextures("blueCouldronSplash"),{}, Beheaded.reelEngineManager);
        seq.timeline.pause();
        seq.item.position = Helper.copyLocalPosition(seq.item, this.collectedTxt);
        seq.item.position.x += -80
        seq.item.position.y += -200

        const seq2 = Beheaded.overlayAnim.playSequence(this.collectedTxt, Beheaded.assetLoader.getTextures("blueSplashBall"),{repeat:-1},Beheaded.ropeCutter);

        let toPos = Helper.copyLocalPosition(this.collectedTxt, Beheaded.baseMultiplier.multSpine);
        
        const durr:number = GameSetting.isFastSpin ? 0.5 : 1;

        tl.add(() => {
            seq.timeline.play();
        },0.1)
        
        tl.fromTo(
            seq2.item,
            { alpha: 0 },
            { duration: 0.3, alpha: 1 }
        ,0.3);
        
        tl.fromTo(
            this.collectedTxt,
            { alpha: 0 },
            { y: this.maxHeight * 0.8, duration: durr, alpha: 1 },0
        );
        // tl.to(this.collectedTxt, {
        //     x:toPos.x,
        //     y:toPos.y,
        //     ease: "Back.easeIn",
        //     duration: durr/2,
        // },durr);
        tl.add(() => {
            seq2.timeline.totalProgress(1);
            this.collectedTxt.alpha = 0;

            // this.addChild(this.collectedTxt);
            Beheaded.baseMultiplier.setValue(Beheaded.baseMultiplier.currentMult + amm);

            // const splash = Beheaded.overlayAnim.playSequence(Beheaded.baseMultiplier.multSpine, Beheaded.assetLoader.getTextures("blueMultiplier_blast"),{duration:0.5},Beheaded.ropeCutter).item;
            // (splash as Sequence).blendMode = BLEND_MODES.ADD;
            // (splash as Sequence).anchor.set(0.6,0.7);
            // (splash as Sequence).scale.set(0.75);
            // splash.alpha = 0.5;

            const splash2 = Beheaded.overlayAnim.playSequence(this.collectedTxt, Beheaded.assetLoader.getTextures("blueMultiplier_blast"),{duration:0.5},Beheaded.ropeCutter).item;
            (splash2 as Sequence).blendMode = BLEND_MODES.ADD;
            (splash2 as Sequence).anchor.set(0.5,0.6);
        })

        return tl;
    }

    protected createReelEngine(): void {
        this._engine = new BeheadedReelEngine(this.engineCallbacks(), this._animationContainer);
        this._engine.stepDistance = this.currentStepDistance;
    }

    public startReel(): void {
        // this.removeSoulWilds();
        if (this.state.isSpinning) return;
        if (!this.isActive) {
            if (this.visible) {
                this.engine.activateNextAnimation();
                this.createNextAnimation(() => this.engine.Idle(), ReelState.IDLE);
            }
            return;
        }

        // Activate the Start-Animation.
        this.engine.activateNextAnimation();
    }

    public createMoveUpDown(reverse: boolean = false, cb?: ReelStartCallbacks): gsap.core.Timeline {
        if (!reverse) {
            this._objects = this.fetchObjsToCut(0);
        }
        return this.engine.MoveRopeUpDown(
            this._objects,
            this.maxHeight + 100,
            reverse ? this.startDuration : 0.5,
            this.config.EASING.DROP,
            reverse
        );
    }

    public createStart(cb?: ReelStartCallbacks, reverse: boolean = false): void {
        this.startCallbacks = cb ? cb : {};
        this.engine.reverse = reverse;

        if (this.isActive) {
            this.cutIndicator = -1;
            this.isAvalanching = false;

            this.createNextAnimation(
                () =>
                    this.engine.StartRope(this.fetchObjsToCut(0), this.maxHeight, this.startDuration, this.config.EASING.DROP),
                ReelState.START
            );
        } else {
            this.createNextAnimation(() => this.engine.Idle(), ReelState.INACTIVE);
        }
    }

    public createAvalancheStart(cb?: ReelStartCallbacks, reverse: boolean = false): void {
        this.startCallbacks = cb ? cb : {};
        this.engine.reverse = reverse;
        if (this.isActive && this.cutIndicator >= 0 && this.cutIndicator < this.symbolConfAmount) {
            this.isAvalanching = true;
            this.createNextAnimation(
                () => this.engine.RopeCut(this.fetchObjsToCut(), this.maxHeight, this.startDuration, this.startEase),
                ReelState.START
            );
        } else {
            this.createNextAnimation(() => this.engine.Idle(), ReelState.INACTIVE);
        }
    }

    private fetchObjsToCut(_indx?: number): PIXI.DisplayObject[] {
        let temp = [];
        const index: number = _indx != undefined ? _indx : this.cutIndicator;

        const cuttedRopes = this.rope.fetchRope(index);
        for (let i = index; i < this.AllSymbols.length; i++) {
            const sym = this.getSymbol(i)!;
            const rope = cuttedRopes.pop()!;
            if(rope) sym.applyRope(rope);
            if(sym) temp.push(sym);
        }
        temp = temp.filter(v => v);
        this._stickyContainer.addChild(...temp);
        return temp;
    }

    public markSymbolCuts(indx?: number): void {
        this.rope.cut();
        return this.getSymbol(indx == undefined ? this.cutIndicator : indx)?.playCut()!;
    }

    parseData(data: any): void {
        super.parseData(data);
    }

    protected onStarting(): void {
        Helper.triggerIfExist(this.startCallbacks.start);

        if (!this.isAvalanching) {
            this.AllSymbols.forEach((sym) => {
                this.tryChangeState(sym, {
                    state: ReelSymbolStates.SPIN,
                    duration: this.startDuration,
                    ease: this.startEase,
                });
            });
        }
    }

    onStopAnimationCompleted(): void {
        super.onStopAnimationCompleted();
    }

    protected setCurrentReelSet(name: string): void {
        super.setCurrentReelSet(name);
    }

    public createStop(cb?: ReelStopCallbacks, attentionStop: boolean = false): gsap.core.Timeline {
        this.stopCallbacks = cb ? cb : {};
        this.attentionStop = attentionStop;

        return this.createNextAnimation(() =>
            this.engine.RopeDrop(this.stopDuration, this.isAvalanching ? this.config.EASING.STOP_AVALANCHE : this.stopEase)
        );
    }

    protected onStopStarted(): void {
        if(this.isAvalanching){
            for (var i = 0; i < this.AllSymbols.length; i++) {
                this.AllSymbols[i].onNewFromAvalanche();
            }
        }
        Helper.triggerIfExist(this.stopCallbacks.stops);
    }

    // Rope Behaviour
    public activateStop(state: string): void {
        this.state.set(state);

        this.rope.buildRope();
        const reelStopReelResult: string[] =
            this.state.equal(ReelState.QUICK_STOP) || GameSetting.isFastSpin ? this._quickStopReelSet : this._stopReelSet;

        const steps: number = this.symbolConfAmount - this.AllSymbols.length;
        const moveDistance: number = steps * this.engine.stepDistance;

        this.AllSymbols.forEach((s) => {
            s.setPosID(s.posID[0] + steps);
        });
        let nextSymindx: number = steps - 1;
        let symbol: BeheadedSymbol;

        for (var i = 0; i < steps; i++) {
            const nextSymName: string =
                reelStopReelResult[nextSymindx] != undefined ? reelStopReelResult[nextSymindx] : this.generateNextSymbol();
            symbol = this.createNewSymbol(nextSymindx, nextSymName, ReelSymbolStates.NORMAL);
            this.addSymbol(symbol);
            symbol.alpha = this.isAvalanching ? 0 : 1;
            nextSymindx--;
        }

        this.AllSymbols.forEach((s) => {
            s.position.y = Math.round(this.engine.stepDistance * s.posID[0]);
        });
        this.engine.activateNextAnimation(this.isAvalanching ? -moveDistance : undefined);
    }

    public overlayGraphicAlpha(toAlpha: number, durr: number): void {
        gsap.to(this._graphArea, { alpha: toAlpha, duration: durr });
    }

    public setSticky(posID: number[]): void {
        posID.forEach((pos) => {
            if (this.getSymbol(pos)) this._stickyContainer.addChild(this.getSymbol(pos)!);
        });
    }

    public mergeSticky(): void {
        this.AllSticky.forEach((child) => {
            this.AllSymbols.find((s) => s.posID[0] === (<BeheadedSymbol>child).posID[0])?.destroy();
        });
        this._animationContainer.addChild(...this.AllSticky);
    }

    public switchRopeLayer(putTop:boolean): void {

        if(this.ropeIsOnSeperated === putTop) return;

        if(putTop){
            this.parent.addChild(this.rope)
            this.parent.sortChildren();
            this.rope.x = this.x;
        }else{
            this._animationContainer.addChild(this.rope)
            this._animationContainer.sortChildren();
            this.rope.x = 0;
        }

        this.ropeIsOnSeperated = putTop;
    }

    public applySymbolInteraction(interact: boolean): void {
        // this.parent.addChild(this.rope);
    }

    public replaceSymbol(sym: BeheadedSymbol, position: number): void {
        this.getSymbol(sym.posID[position])?.destroy();
        this.addSymbol(sym);
    }

    public playAttention(active: boolean): void {
        this.attentionSeq.play({
            repeat: active ? -1 : 0,
            onStart: () => {
                this.attentionSeq.visible = true;
            },
            onCompleteCallback: () => (this.attentionSeq.visible = false),
        });
        gsap.to(this.attentionSeq, { alpha: active ? 1 : 0, duration: this.attentionSeq.totalDuration });
    }

    public symPos(symID: number): PIXI.Point {
        return MathHelper.pointAdd(this.getSymbol(symID)!.position, this.position);
    }
}
